import {createElement, ReactNode} from 'react';
import {BleskIcon} from '../../icons';

interface PageEmptyStateProps {
  icon?: BleskIcon;
  title: ReactNode;
  text: ReactNode;
}

export const PageEmptyState = ({icon, title, text}: PageEmptyStateProps) => {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3">
      {icon && createElement(icon, {className: 'size-16 text-text-secondary'})}
      <h2 className="text-title-h2">{title}</h2>
      <p className="text-paragraph-lg text-text-secondary">{text}</p>
    </div>
  );
};
